"use strict";
exports.__esModule = true;
exports.utmGrabber = void 0;
function utmGrabber() {
    handleReferrer();
    handleUTMGrabbing();
    handleSetFirstKnownUtmDate();
}
exports.utmGrabber = utmGrabber;
function getDomain() {
    return window.location.hostname.includes("apollographql.com")
        ? "domain=apollographql.com;"
        : "";
}
var firstKnownUtmDateCookieName = "first_known_utm_date";
// cookie max-age set to 30 days (measured in seconds)
var expireTime = 60 * 60 * 24 * 30;
// setting first known cookie expiry to 400 days
var firstKnownExpireTime = 34560000;
// check to see if first_known_utm_date exists
var getFirstKnownUtmDate = function () { return getCookie(firstKnownUtmDateCookieName); };
var utmParams = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "utm_icid",
    "utm_ICID",
    "referrer",
];
var searchEngines = [
    {
        name: "google",
        url: "http://www.google.com",
        source: "google"
    },
    {
        name: "bing",
        url: "http://www.bing.com",
        source: "bing"
    },
    {
        name: "yahoo",
        url: "http://www.yahoo.com",
        source: "yahoo"
    },
    {
        name: "duckduckgo",
        url: "https://duckduckgo.com/",
        source: "duckduckgo"
    },
    {
        name: "baidu",
        url: "http://www.baidu.com",
        source: "baidu"
    },
    {
        name: "yandex",
        url: "http://www.yandex.com",
        source: "yandex"
    },
    {
        name: "ecosia",
        url: "https://www.ecosia.org/",
        source: "ecosia.org"
    },
];
function getCookie(name) {
    var nameEQ = "".concat(name, "=");
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ")
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return c.substring(nameEQ.length, c.length);
    }
    return null;
}
function deleteCookie(name) {
    document.cookie = "".concat(name, "=; path=/; samesite=lax; ").concat(getDomain(), " expires=Thu, 01 Jan 1970 00:00:01 GMT;");
}
function handleReferrer() {
    var referrer = document.referrer;
    if (referrer === "" || referrer === null || referrer === "undefined") {
        var domain_1 = getDomain();
        if (!getCookie("utm_source")) {
            document.cookie = "utm_source=direct; samesite=lax; path=/; ".concat(domain_1, " max-age=").concat(expireTime);
        }
        if (!getFirstKnownUtmDate()) {
            // set first known cookie
            document.cookie = "first_known_utm_source=direct; samesite=lax; path=/; ".concat(domain_1, " max-age=").concat(firstKnownExpireTime);
        }
        return;
    }
    // sometimes blog -> apollographql.com is populating referrer,
    // the following is to prevent referrer cookie from being populated for internal links
    if (referrer.includes("apollographql.com")) {
        return;
    }
    // check if utm cookies exist, delete them if they do before we set new ones
    utmParams.forEach(function (param) {
        var cValue = getCookie(param);
        if (cValue) {
            deleteCookie(param);
        }
    });
    // check to see if referrer exists in search engines list
    var matchedSearchEngine = searchEngines.filter(function (engine) {
        return referrer.includes(engine.name);
    });
    var domain = getDomain();
    var firstKnownUtmDate = getFirstKnownUtmDate();
    if (matchedSearchEngine.length > 0) {
        // referrer is a search engine, update medium
        document.cookie = "utm_medium=organic; samesite=lax; path=/; ".concat(domain, " max-age=").concat(expireTime);
        document.cookie = "utm_source=".concat(matchedSearchEngine[0].source, "; samesite=lax; path=/; ").concat(domain, " max-age=").concat(expireTime);
        // set first known cookies
        if (!firstKnownUtmDate) {
            document.cookie = "first_known_utm_medium=organic; samesite=lax; path=/; ".concat(domain, " max-age=").concat(firstKnownExpireTime);
            document.cookie = "first_known_utm_source=".concat(matchedSearchEngine[0].source, "; samesite=lax; path=/; ").concat(domain, " max-age=").concat(firstKnownExpireTime);
        }
    }
    else {
        document.cookie = "utm_medium=referral; samesite=lax; path=/; ".concat(domain, " max-age=").concat(expireTime);
        document.cookie = "utm_source=".concat(referrer, "; samesite=lax; path=/; ").concat(domain, " max-age=").concat(expireTime);
        // set first known cookies
        if (!firstKnownUtmDate) {
            document.cookie = "first_known_utm_medium=referral; samesite=lax; path=/; ".concat(domain, " max-age=").concat(firstKnownExpireTime);
            document.cookie = "first_known_utm_source=".concat(referrer, "; samesite=lax; path=/; ").concat(domain, " max-age=").concat(firstKnownExpireTime);
        }
    }
}
function handleUTMGrabbing() {
    var utmQuery = decodeURIComponent(window.location.search.substring(1));
    var utmVariables = utmQuery.split("&");
    var ParameterName;
    var i;
    var getUTMValue = function (inputParameter) {
        for (i = 0; i < utmVariables.length; i++) {
            ParameterName = utmVariables[i].split("=");
            if (ParameterName[0] === inputParameter) {
                return ParameterName[1] === null ? null : ParameterName[1];
            }
        }
    };
    var valueExists = function (value) {
        return value !== null && value !== "" && value !== undefined;
    };
    var utmsExist = false;
    var domain = getDomain();
    var firstKnownUtmDate = getFirstKnownUtmDate();
    utmParams.forEach(function (param) {
        var pValue = getUTMValue(param);
        if (valueExists(pValue)) {
            utmsExist = true;
            // if an existing cookie is present, delete it before setting new one
            deleteCookie(param);
            document.cookie = "".concat(param, "=").concat(pValue, "; samesite=lax; path=/; ").concat(domain, " max-age=").concat(expireTime);
            // see if first known cookie exists
            if (!firstKnownUtmDate) {
                // set first known cookie
                document.cookie = "first_known_".concat(param, "=").concat(pValue, "; samesite=lax; path=/; ").concat(domain, " max-age=").concat(firstKnownExpireTime);
            }
        }
    });
    if (!utmsExist) {
        // no utms exist at this point, check for source/medium cookies, an if they don't exist - set them to direct/website
        if (!getCookie("utm_medium")) {
            document.cookie = "utm_medium=website; samesite=lax; path=/; ".concat(domain, " max-age=").concat(expireTime);
            if (!firstKnownUtmDate) {
                document.cookie = "first_known_utm_medium=website; samesite=lax; path=/; ".concat(domain, " max-age=").concat(firstKnownExpireTime);
            }
        }
        if (!getCookie("utm_source")) {
            document.cookie = "utm_source=direct; samesite=lax; path=/; ".concat(domain, " max-age=").concat(expireTime);
            if (!firstKnownUtmDate) {
                document.cookie = "first_known_utm_source=direct; samesite=lax; path=/; ".concat(domain, " max-age=").concat(firstKnownExpireTime);
            }
        }
    }
}
function handleSetFirstKnownUtmDate() {
    // set current date to stamp first visit
    var now = new Date();
    var isoString = now.toISOString();
    var firstKnownUtmDate = getFirstKnownUtmDate();
    // if cookie doesn't exist, we set it
    if (!firstKnownUtmDate) {
        var domain = getDomain();
        document.cookie = "".concat(firstKnownUtmDateCookieName, "=").concat(isoString, "; samesite=lax; path=/; ").concat(domain, " max-age=").concat(firstKnownExpireTime);
    }
}
